import React from 'react';
import '../styles/Footer.scss';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="brand">
                        <h3>ODYSSEY</h3>
                        <p>The Future of Travel.</p>
                    </div>
                    <div className="links">
                        <a href="/">Home</a>
                        <a href="/about">About</a>
                        <a href="/fleet">Fleet</a>
                        <a href="#booking">Book</a>
                    </div>
                </div>
                <div className="copyright">
                    &copy; 2099 Odyssey Spaceflight. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
